import BaseService from "./BaseService";

const API_TASKS = `${process.env.VUE_APP_BACKEND_API}/Tasks`;

class TasksService extends BaseService
{
    /**
     * Get all the unviewed tasks of a user.
     * 
     * @return {Promise}
     */
    static getUserTasks()
    {
        if(!this.hasSession())
            return Promise.reject();

        return window.axios.get(API_TASKS);
    }

    /**
     * Mark a task as read or unread.
     * 
     * @param {Int} taskId
     * @param {Boolean} read
     * 
     * @return {Promise}
     */
    static markTaskAsRead(taskId, read = true)
    {
        if(!this.hasSession())
            return Promise.reject();

        let body = { state: read };
        let url = `${API_TASKS}/${taskId}/MarkAsRead`;

        return window.axios.put(url, body);
    }
}

export default TasksService;
